import {
  DirectoryRecordFieldData,
  DirectorySchemaData,
  MultiLanguageTextData,
} from 'api/types/data/directory/directory';

/**
 * Retrieves the value of a directory field, considering possible references to other records.
 * If the field is a reference, recursively extracts the value from the referenced record.
 *
 * @param fieldValue - The directory field value
 * @param currentSchema - The schema of the current directory
 * @param directorySchemas - List of all directory schemas
 */
export const getDirectoryFieldValue = (
  fieldValue: DirectoryRecordFieldData,
  currentSchema: DirectorySchemaData,
  directorySchemas: DirectorySchemaData[]
): string | MultiLanguageTextData | boolean | undefined | number => {
  // Check if the field is a reference to another record
  if (fieldValue.referenceRecord) {
    // Find the field definition in the current schema
    const reference = currentSchema.fieldDefinitions.find(
      (field) => field.name === fieldValue.name
    )?.reference;

    if (reference) {
      // Find the schema that the field references
      const referenceSchema = directorySchemas.find(
        (schema) => schema.name === reference.directorySchemaName
      );

      if (referenceSchema) {
        // Find the referenced field value in the referenced record
        const referenceFieldValue = fieldValue.referenceRecord.fields.find(
          (field) => field.name === reference.fieldName
        );

        if (referenceFieldValue) {
          // Recursively get the value from the referenced record
          return getDirectoryFieldValue(
            referenceFieldValue,
            referenceSchema,
            directorySchemas
          );
        }
      }
    }
  }
  // Return the value if not a reference
  return fieldValue.value ?? undefined;
};
